<script>
  //import Play from "./Play.svelte"
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <h3>如何使用【XiYi 習易網】</h3>
  <h4>一般訪客</h4>
  <p>
    謝謝您來到【XiYi
    習易網】！這裡主要是為學易的朋友提供一個較為方便習易網的環境，不賣廣告欄位、也不出售會員資料，並沒有打算吸引很多訪客，
    也不期待會有很多訪客，所以也就沒有很多免費的內容。以下是您能看到的幾項訊息：
  </p>
  <img
    class="navbar-pic center"
    src="/images/guestNavbar.png"
    alt="Guest navbar"
  />
  <ul>
    <li>
      繁體/簡體轉換：【XiYi
      習易網】是以繁體字（正體字）為基準。如果您習慣使用簡體字，可以很方便地轉換。
      目前還沒找到100%正確的繁體簡體轉換開源工具，尤其是破音字和古文的轉換，如果您看到有任何錯誤的文字，
      請告知以便更正。謝謝！
    </li>
    <li>
      使用示範：就是您所在的頁面。如果，您對本站所提供的服務有興趣，請往下看所有的會員功能介紹。
    </li>
    <li>
      古籍：古今中外，有關易經的書籍非常多。在【XiYi
      習易網】裡，目前我只放了最基本的周易、十翼原始經文和朱熹的卦序歌。既然來了，不妨順便讀讀古書。
    </li>
    <li>關於：介紹本站的理念、我是誰、等等。</li>
    <li>註冊，登入：歡迎註冊成為會員！</li>
  </ul>
  <br />
  <h5>訪客基本功能示範</h5>
  <div class="video">
    <!-- <iframe
      src="https://player.vimeo.com/video/534597991?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      title="XiYi guest usage"
    /> -->
    <iframe
      src="https://www.youtube.com/embed/QhrpWrmD_5c"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
    <!-- <iframe
      src="https://www.youtube.com/embed/SiQE6w40yeU"
      frameborder="0"
      allow="autoplay; fullscreen"
      allowfullscreen
    /> -->
  </div>

  <h4>註冊試用、付費會員</h4>
  <p>
    註冊的手續很簡單，只要點擊【註冊】、填個簡單的表格就可以了，無需信用卡或任何敏感資料。其中，您的email地址是最重要的，系統會自動寄一封確認的email給您（如下圖）：
  </p>
  <img
    class="navbar-pic center"
    src="/images/confirmationEmail.png"
    alt="Confrimation Email"
  />
  <p>
    請到您的電子郵件信箱，打開那一封由【XiYi
    習易網】寄給您的email、並點擊確認連結，這樣才算註冊完成。您的email就是您在【XiYi
    習易網】的永久正式帳號。
  </p>

  <img
    class="navbar-pic-small center"
    src="/images/confirmationMsg.png"
    alt="Confrimation Message"
  />

  <p>
    一旦註冊完成，您會有7天的免費試用期。心裡想要「學」易的人本來就不多，真正願意花時間力氣「習」易的人更少。
    我在這裏要祝賀、並謝謝您完成了第一步！成為會員後，您能看到【XiYi
    習易網】所有的會員功能：
  </p>
  <img
    class="navbar-pic center"
    src="/images/memberNavbar.png"
    alt="Member navbar"
  />
  <br />
  <h5>會員功能示範</h5>
  <div class="video">
    <!-- <iframe
      src="https://player.vimeo.com/video/531922957?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      title="dogcat.mov"
    /> -->
    <!-- <iframe
      src="https://www.youtube.com/embed/SiQE6w40yeU"
      frameborder="0"
      allow="autoplay; fullscreen"
      allowfullscreen
    /> -->
    <iframe
      src="https://www.youtube.com/embed/1tde1mU7btQ"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
{:else}
  <h3>如何使用【XiYi 习易网】</h3>
  <h4>一般访客</h4>
  <p>
    谢谢您来到【XiYi
    习易网】！这里主要是为学易的朋友提供一个较为方便习易网的环境，不卖广告栏位、也不出售会员资料，并没有打算吸引很多访客，
    也不期待会有很多访客，所以也就没有很多免费的内容。以下是您能看到的几项讯息：
  </p>
  <img
    class="navbar-pic center"
    src="/images/guestNavbarCN.png"
    alt="Guest navbar"
  />
  <ul>
    <li>
      繁体/简体转换：【XiYi
      习易网】是以繁体字（正体字）为基准。如果您习惯使用简体字，可以很方便地转换。
      目前还没找到100%正确的繁体简体转换开源工具，尤其是破音字和古文的转换，如果您看到有任何错误的文字，
      请告知以便更正。谢谢！
    </li>
    <li>
      使用示范：就是您所在的页面。如果，您对本站所提供的服务有兴趣，请往下看所有的会员功能介绍。
    </li>
    <li>
      古籍：古今中外，有关易经的书籍非常多。在【XiYi
      习易网】里，目前我只放了最基本的周易、十翼原始经文和朱熹的卦序歌。既然来了，不妨顺便读读古书。
    </li>
    <li>关于：介绍本站的理念、我是谁、等等。</li>
    <li>注册，登入：欢迎注册成为会员！</li>
  </ul>
  <br />
  <h5>访客基本功能示范</h5>
  <div class="video">
    <iframe
      src="https://www.youtube.com/embed/QhrpWrmD_5c"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
    <!-- <iframe
      src="https://player.vimeo.com/video/531922957?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      title="dogcat.mov"
    /> -->
  </div>

  <h4>注册试用、付费会员</h4>
  <p>
    注册的手续很简单，只要点击【注册】、填个简单的表格就可以了，无需信用卡或任何敏感资料。其中，您的email地址是最重要的，系统会自动寄一封确认的email给您（如下图）：
  </p>
  <img
    class="navbar-pic center"
    src="/images/confirmationEmail.png"
    alt="Confrimation Email"
  />
  <p>
    请到您的电子邮件信箱，打开那一封由【XiYi
    习易网】寄给您的email、并点击确认连结，这样才算注册完成。您的email就是您在【XiYi
    习易网】的永久正式帐号。
  </p>

  <img
    class="navbar-pic-small center"
    src="/images/confirmationMsg.png"
    alt="Confrimation Message"
  />

  <p>
    一旦注册完成，您会有7天的免费试用期。心里想要「学」易的人本来就不多，真正愿意花时间力气「习」易的人更少。
    我在这里要祝贺、并谢谢您完成了第一步！成为会员后，您能看到【XiYi
    习易网】所有的会员功能：
  </p>
  <img
    class="navbar-pic center"
    src="/images/memberNavbarCN.png"
    alt="Member navbar"
  />
  <br />
  <h5>会员功能示范</h5>
  <div class="video">
    <!--  <iframe
      src="https://player.vimeo.com/video/531922957?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      title="dogcat.mov"
    /> -->
    <iframe
      src="https://www.youtube.com/embed/1tde1mU7btQ"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
{/if}

<style>
  p {
    font-size: 16px;
  }
  li {
    font-size: 16px;
  }
  ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
  .navbar-pic {
    width: 100%;
    border: solid #7986cb 2px;
  }
  .navbar-pic-small {
    width: 50%;
    border: solid #7986cb 2px;
  }
  /* .video {
  } */
</style>
